import {
  get
} from 'core-js/core/dict'
import request from '../utils/request'

// 示例API接口
export const api = {
  // 获取首页数据
  getHomeData(params) {
    return request({
      url: '/home/data',
      method: 'get',
      params
    })
  },

  // 获取首页顶部分类数据
  getHomeTabs() {
    return request({
      url: '/m13759/641590baa0d47',
      method: 'post'
    })
  },
  // 获取首页第二模块tabs数据
  getCenterList(data) {
    return request({
      url: '/m13759/641591a873763',
      method: 'post',
      data
    })
  },

  // 获取首页第二模块tabs数据
  getSecondShopList(data) {
    return request({
      url: '/m13759/64184ac1cafc3',
      method: 'post',
      data
    })
  },

  // 获取采购大厅订单金额区间
  getCgdtMoneyList1() {
    return request({
      url: '/m13759/68edf6941bbe6',
      method: 'post'
    })
  },

  // 获取采购大厅列表
  getCgdtList(data) {
    return request({
      url: '/m13759/68d1072023e3e',
      method: 'post',
      data
    })
  },

  // 获取首页第一模块轮播图
  getHomeShopBanner(data) {
    return request({
      url: '/m13759/641e624160dd0',
      method: 'post',
      data
    })
  },

  // 获取首页商品分类
  getHomeShopFenlei() {
    return request({
      url: '/m13759/63e369d925758',
      method: 'post'
    })
  },

  // 获取供应大厅分类
  getSupplyHallList(data) {
    return request({
      url: '/m13759/64184ac1cafc3',
      method: 'post',
      data
    })
  },

  // 获取商家推广
  getShangjiaTuiGuang(data) {
    return request({
      url: '/m13759/68c53bbd08791',
      method: 'post',
      data
    })
  },

  // 获取搏亿学堂的Tabs
  getBoyixuetangTabs() {
    return request({
      url: '/m13759/693f796075e89',
      method: 'post'
    })
  },
  // 获取搏亿学堂的列表
  getBoyixuetangList(data) {
    return request({
      url: '/m13759/68f09392183ea',
      method: 'post',
      data
    })
  },

  // 获取博弈学堂详情
  getBoyixuetangDetail(data) {
    return request({
      url: '/m13759/641576c24de11',
      method: 'post',
      data
    })
  },

  // 获取供应大厅产地列表
  getChandiList() {
    return request({
      url: '/m13759/6902df4ddca0a',
      method: 'post'
    })
  },

  // 获取商家热销
  getRexiao(data) {
    return request({
      url: '/m13759/6945f827a941e',
      method: 'post',
      data
    })
  },

  // 提交表单数据
  submitForm(data) {
    return request({
      url: '/form/submit',
      method: 'post',
      data
    })
  },

  // 获取行情列表
  getMarketList(data) {
    return request({
      url: '/m13759/68ff09e100c32',
      method: 'post',
      data
    })
  },

  // 获取商品详情信息
  getProductInfo(data) {
    return request({
      url: '/m13759/641987361d887',
      method: 'post',
      data
    })
  },
  // 获取商品评价列表tabs
  getCommentTabs(data) {
    return request({
      url: '/m13759/641ae5b3d5bba',
      method: 'post',
      data
    })
  },

  //获取商品评价列表
  getCommentList(data) {
    return request({
      url: '/m13759/641ad7c486389',
      method: 'post',
      data
    })
  },

  // 收藏、取消收藏
  collectShop(data) {
    return request({
      url: '/m13759/636caf10164ce',
      method: 'post',
      data
    })
  },

  // 关注店铺
  guanzhuShop(data) {
    return request({
      url: '/m13759/637ca14c548eb',
      method: 'post',
      data
    })
  },

  // 取消关注店铺
  cancleGuanzhuShop(data) {
    return request({
      url: '/m13759/637ca2333f0be',
      method: 'post',
      data
    })
  },

  // 获取收货地址列表
  getAddressList(data) {
    return request({
      url: '/m13759/636f7683cf195',
      method: 'post',
      data
    })
  },
  // 获取地址标签
  getAddressTag() {
    return request({
      url: '/m13759/5ff6859e3c4fd',
      method: 'post'
    })
  },
  // 新增收货地址
  newAddressFn(data) {
    return request({
      url: '/m13759/637defdbd53ef',
      method: 'post',
      data
    })
  },
  // 编辑收货地址
  editAddressFn(data) {
    return request({
      url: '/m13759/637df1ea39d16',
      method: 'post',
      data
    })
  },
  // 删除地址
  deleteAddressFn(data) {
    return request({
      url: '/m13759/636f773e8d763',
      method: 'post',
      data
    })
  },

  // 设置默认地址
  setAddressFn(data) {
    return request({
      url: '/m13759/6389ad65f28d9',
      method: 'post',
      data
    })
  },

  // 获取发票列表
  getFapiaoList(data) {
    return request({
      url: '/m13759/641848d371e2f',
      method: 'post',
      data
    })
  },

  // 新增发票
  newFapiaoFn(data) {
    return request({
      url: '/m13759/641ec735afc0f',
      method: 'post',
      data
    })
  },

  // 编辑发票
  editFapiaoFn(data) {
    return request({
      url: '/m13759/641ec88074922',
      method: 'post',
      data
    })
  },

  // 删除发票
  deleteFapiaoFn(data) {
    return request({
      url: '/m13759/641ec9d300c00',
      method: 'post',
      data
    })
  },

  // 设置默认发票
  setFapiaoFn(data) {
    return request({
      url: '/m13759/647efc94037dd',
      method: 'post',
      data
    })
  },

  // 获取优惠券列表
  getCouponList(data) {
    return request({
      url: '/m13759/64198610a95ca',
      method: 'post',
      data
    })
  },

  // 获取采购分类
  getPurchaseCategory() {
    return request({
      url: '/m13759/68ee040776a0f',
      method: 'post'
    })
  },

  // 发布采购
  submitPurchaseOrder(data) {
    return request({
      url: '/m13759/68c51f5e1522e',
      method: 'post',
      data
    })
  },


  // 提交订单
  submitOrder(data) {
    return request({
      url: '/m13759/62c8038d96dab',
      method: 'post',
      data
    })
  },

  // 余额支付
  balancePay(data) {
    return request({
      url: '/m13759/641ea9f00a6ae',
      method: 'post',
      data
    })
  },

  //获取订单支付信息
  getOrderPayInfo(data) {
    return request({
      url: '/m13759/64215178a23ec',
      method: 'post',
      data
    })
  },

  // 获取行情详情信息
  getMarketInfo(data) {
    return request({
      url: '/m13759/68ff0f50c1322',
      method: 'post',
      data
    })
  },

  // 获取省市区列表
  getAreaList() {
    return request({
      url: '/m13759/66f2a53c0acb0',
      method: 'post'
    })
  },

  // 获取商家详情
  getStoreInfo(data) {
    return request({
      url: '/m13759/68f5f7d981fe4',
      method: 'post',
      data
    })
  },

  // 获取商家店铺商品列表
  getStoreProductList(data) {
    return request({
      url: '/m13759/67ecf1258cd0a',
      method: 'post',
      data
    })
  },

  // 文件上传
  uploadFile(data) {
    return request({
      url: '/file/upload',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 密码登录
  passwordLogin(data) {
    return request({
      url: '/m13759/5c78dbfd977cf',
      method: 'post',
      data
    })
  },
  // 验证码登录
  codeLogin(data) {
    return request({
      url: '/m13759/5c78dca45ebc1',
      method: 'post',
      data
    })
  },
  // 获取验证码
  getVerificationCode(data) {
    return request({
      url: '/m13759/5b5bdc44796e8',
      method: 'post',
      data
    })
  },
  // 注册
  register(data) {
    return request({
      url: '/m13759/5cad9f63e4f94',
      method: 'post',
      data
    })
  },
  // 获取用户信息
  userInfo(data) {
    return request({
      url: '/m13759/5c78c4772da97',
      method: 'post',
      data
    })
  },
  // 编辑用户信息
  editInfo(data) {
    return request({
      url: '/m13759/5cb54af125f1c',
      method: 'post',
      data
    })
  },
  //开店可享
  getShopEntry() {
    return request({
      url: '/m13759/691fc89d2419a',
      method: 'post'
    })
  },
  //个人信息的认证
  realName(data) {
    return request({
      url: '/m13759/62bd90cc2f5d0',
      method: 'post',
      data
    })
  },
  //获取行业分类
  getIndustryList() {
    return request({
      url: '/m13759/6371eeabae0df',
      method: 'post'
    })
  },
  //提交店铺信息
  submitShopInfo(data) {
    return request({
      url: '/m13759/62bd977cbc707',
      method: 'post',
      data
    })
  },
  // 获取店铺审核信息
  getShopReviewInfo() {
    return request({
      url: '/m13759/62be7019e6ae4',
      method: 'post'
    })
  },
  // 获取店铺信息
  getShopInfo(data) {
    return request({
      url: '/m13759/641b0ae793987',
      method: 'post',
      data
    })
  },
  // 获取店铺订单数量
  getShopOrderNum(data) {
    return request({
      url: '/m13759/691bc9b76cdfc',
      method: 'post',
      data
    })
  },
  // 获取店铺订单统计数据
  getShopOrderStats(data) {
    return request({
      url: '/m13759/691ab4af99b23',
      method: 'post',
      data
    })
  },
  //获取店铺销售数据
  getShopSales(data) {
    return request({
      url: '/m13759/691ab6f7d4bf1',
      method: 'post',
      data
    })
  },
  //获取店铺订单数据
  getShopOrderData(data) {
    return request({
      url: '/m13759/691acb283f285',
      method: 'post',
      data
    })
  },
  //获取店铺订单列表
  getShopOrderList(data) {
    return request({
      url: '/m13759/642f7c4fe3866',
      method: 'post',
      data
    })
  },
  // 获取店铺订单详情
  getShopOrderDetail(data) {
    return request({
      url: '/m13759/642fb0d327172',
      method: 'post',
      data
    })
  },
  // 获取物流公司列表
  getLogisticsCompany() {
    return request({
      url: '/m13759/6427e3a822643',
      method: 'post'
    })
  },
  // 店铺发货
  confirmShipment(data) {
    return request({
      url: '/m13759/643132c735500',
      method: 'post',
      data
    })
  },
  // 获取物流信息
  getLogisticsInfo(data) {
    return request({
      url: '/m13759/6421827328ff0',
      method: 'post',
      data
    })
  },
  // 获取店铺售后订单列表
  getShopAfterOrderList(data) {
    return request({
      url: '/m13759/642fe0dd33126',
      method: 'post',
      data
    })
  },
  //获取店铺售后订单详情
  getShopAfterOrderDetail(data) {
    return request({
      url: '/m13759/6427d6b5d3599',
      method: 'post',
      data
    })
  },
  // 获取商品列表
  getShopProductList(data) {
    return request({
      url: '/m13759/642e81587f886',
      method: 'post',
      data
    })
  },

  // 同意退款
  agreeRefund(data) {
    return request({
      url: '/m13759/64312e713d2ee',
      method: 'post',
      data
    })
  },
  // 拒绝退款
  refuseRefund(data) {
    return request({
      url: '/m13759/643129dbd6474',
      method: 'post',
      data
    })
  },
  // 确认退款
  confirmRefund(data) {
    return request({
      url: '/m13759/64312fdfde8e1',
      method: 'post',
      data
    })
  },

  //获取评价列表
  commentList(data) {
    return request({
      url: '/m13759/642fd43abf4e2',
      method: 'post',
      data
    })
  },
  //获取采购详情
  purchaseDetails(data) {
    return request({
      url: '/m13759/68c7e3dc9f3df',
      method: 'post',
      data
    })
  },
  // 是否能报价
  isPurchase(data) {
    return request({
      url: '/m13759/68c7d7a0a0df5',
      method: 'post',
      data
    })
  },
  // 今日是否报价
  dayPurchase(data) {
    return request({
      url: '/m13759/68f1f6f980272',
      method: 'post',
      data
    })
  },
  // 报价商品列表
  purchaseGoods() {
    return request({
      url: '/m13759/68c7cb00211ed',
      method: 'post',
    })
  },
  // 提交今日报价
  todayQuotation(data) {
    return request({
      url: '/m13759/68c7d0b602d08',
      method: 'post',
      data
    })
  },
  // 报价折扣率
  discountQuotation() {
    return request({
      url: '/m13759/68f8450b863a9',
      method: 'post',
    })
  },
  // 提价报价
  submitQuotation(data) {
    return request({
      url: '/m13759/68c7d463eabbb',
      method: 'post',
      data
    })
  },
  // 退出报价
  exitQuotation(data) {
    return request({
      url: '/m13759/68cd0b8c780ce',
      method: 'post',
      data
    })
  },
  // 延时配载
  applyDelayLoading(data) {
    return request({
      url: '/m13759/68ccb71c5c570',
      method: 'post',
      data
    })
  },
  // 提交配载
  submitStowage(data) {
    return request({
      url: '/m13759/68cbc52b066fe',
      method: 'post',
      data
    })
  },

  // 获取运费模板列表
  getFreightTemplateList(data) {
    return request({
      url: '/m13759/642be6d4920df',
      method: 'post',
      data
    })
  },
  // 财务统计
  getFinancialStats(data) {
    return request({
      url: '/m13759/644b3ae43785a',
      method: 'post',
      data
    })
  },
  // 获取财务列表
  getFinancialList(data) {
    return request({
      url: '/m13759/644b5e0ce64bb',
      method: 'post',
      data
    })
  },
  // 获取金额明细统计
  getCgdtMoneyAll(data) {
    return request({
      url: '/m13759/644ba15b98b0b',
      method: 'post',
      data
    })
  },
  // 获取金额明细列表
  getCgdtMoneyList(data) {
    return request({
      url: '/m13759/644b8b8b56f8f',
      method: 'post',
      data
    })
  },
  // 获取提现记录列表
  getWithdrawalList(data) {
    return request({
      url: '/m13759/644a2524d43e0',
      method: 'post',
      data
    })
  },
  // 获取提现统计
  getWithdrawalStats(data) {
    return request({
      url: '/m13759/644b2e88741af',
      method: 'post',
      data
    })
  },
  // 添加商品
  addProduct(data) {
    return request({
      url: '/m13759/694e382d82d48',
      method: 'post',
      data
    })
  },
  // 比价列表
  getPriceComparisonList(data) {
    return request({
      url: '/m13759/68c51f858dd40',
      method: 'post',
      data
    })
  },
  // 获取比价订单详情
  getPriceComparisonDetail(data) {
    return request({
      url: '/m13759/68c7e3dc9f3df',
      method: 'post',
      data
    })
  },
  //获取折扣率
  getDiscountList(data) {
    return request({
      url: '/m13759/68f8450b863a9',
      method: 'post',
      data
    })
  },
  //删除商品
  deleteShopProduct(data) {
    return request({
      url: '/m13759/642e85ecdd248',
      method: 'post',
      data
    })
  },
  // 上架/下架商品
  updateShopProductStatus(data) {
    return request({
      url: '/m13759/642e84501461b',
      method: 'post',
      data
    })
  },

  // 获取指定推广时间
  getZhidingTime(data) {
    return request({
      url: '/m13759/68c51d2b8beae',
      method: 'post',
      data
    })
  },

  // 发布推广
  publishTuiguang(data) {
    return request({
      url: '/m13759/68c5322751196',
      method: 'post',
      data
    })
  },
  // 获取推广详情
  getTuiguangDetail(data) {
    return request({
      url: '/m13759/68c54368179fc',
      method: 'post',
      data
    })
  },

  // 获取订单红点数量
  getOrderRedDotCount() {
    return request({
      url: '/m13759/644ceb577e29e',
      method: 'post'
    })
  },
  // 获取会员套餐
  getIntervalPrecision() {
    return request({
      url: '/m13759/68d20984e5ae4',
      method: 'post'
    })
  },
  // 购买会员
  buyMember(data) {
    return request({
      url: '/m13759/67e67234a704a',
      method: 'post',
      data
    })
  },
  // 获取图片上传参数
  getUploadParams(data) {
    return request({
      url: '/v1/6454d9663e508',
      method: 'post',
      data,
    })
  },


  // 获取订单列表
  getOrderList(data) {
    return request({
      url: '/m13759/62c8f31da5eaa',
      method: 'post',
      data
    })
  },
  // 获取售后列表
  getRefundList(data) {
    return request({
      url: '/m13759/6427d125edfc5',
      method: 'post',
      data
    })
  },

  // 获取订单取消原因列表
  getCancelOrderReasons(data) {
    return request({
      url: '/m13759/641ae6544d2d5',
      method: 'post',
      data
    })
  },

  //确认取消
  cancelOrder(data) {
    return request({
      url: '/m13759/62cb8b8438141',
      method: 'post',
      data
    })
  },

  // 删除订单
  deleteOrder(data) {
    return request({
      url: '/m13759/6447c3b69f234',
      method: 'post',
      data
    })
  },
  // 获取订单详情
  getOrderDetail(data) {
    return request({
      url: '/m13759/62c92b9d5ada3',
      method: 'post',
      data
    })
  },

  // 提醒发货
  remindDelivery(data) {
    return request({
      url: '/m13759/62bec4f86725d',
      method: 'post',
      data
    })
  },

  // 获取评价列表
  getPingjiaList(data) {
    return request({
      url: '/m13759/68fad8f2a26e1',
      method: 'post',
      data
    })
  },

  // 提交评价
  submitPingjia(data) {
    return request({
      url: '/m13759/64218d79d9401',
      method: 'post',
      data
    })
  },

  // 确认收货
  confirmReceipt(data) {
    return request({
      url: '/m13759/64218bff49e61',
      method: 'post',
      data
    })
  },

  // 获取售后商品详情
  getRefundGoodsDetail(data) {
    return request({
      url: '/m13759/64258181598c7',
      method: 'post',
      data
    })
  },

  // 获取售后原因列表
  getRefundReasons(data) {
    return request({
      url: '/m13759/641ae6544d2d5',
      method: 'post',
      data
    })
  },
  // 提交售后
  submitRefund(data) {
    return request({
      url: '/m13759/64219b8235a5e',
      method: 'post',
      data
    })
  },
  // 获取退款金额
  getRefundPrice(data) {
    return request({
      url: '/m13759/64257c480b1a1',
      method: 'post',
      data
    })
  },


  // 撤销售后申请
  cancelRefund(data) {
    return request({
      url: '/m13759/6427d9581deed',
      method: 'post',
      data
    })
  },

  // 删除售后订单
  deleteRefundOrder(data) {
    return request({
      url: '/m13759/6427dbbacba58',
      method: 'post',
      data
    })
  },

  // 获取物流公司
  getLogisticsCompany(data) {
    return request({
      url: '/m13759/6427e3a822643',
      method: 'post',
      data
    })
  },

  // 提交售后寄回信息
  submitReturnInfo(data) {
    return request({
      url: '/m13759/6427dab6182fa',
      method: 'post',
      data
    })
  },

  // 查看售后订单物流
  getReturnLogistics(data) {
    return request({
      url: '/m13759/6447c1b701129',
      method: 'post',
      data
    })
  },

  // 获取充值选项
  getRechargeOptions(data) {
    return request({
      url: '/m13759/636f522d2dbe9',
      method: 'post',
      data
    })
  },

  // 获取钱包详情
  getWalletDetail(data) {
    return request({
      url: '/m13759/636d04052bb00',
      method: 'post',
      data
    })
  },

  // 余额明细
  getBalanceDetail(data) {
    return request({
      url: '/m13759/636dfee37deef',
      method: 'post',
      data
    })
  },

  // 提现明细
  getWithdrawDetail(data) {
    return request({
      url: '/m13759/636f481b67084',
      method: 'post',
      data
    })
  },

  // 我的收藏列表
  getMyCollectionList(data) {
    return request({
      url: '/m13759/636cabd662b22',
      method: 'post',
      data
    })
  },

  // 取消收藏
  cancelCollection(data) {
    return request({
      url: '/m13759/636caf10164ce',
      method: 'post',
      data
    })
  },

  // 我的店铺关注列表
  getMyShopFollowList(data) {
    return request({
      url: '/m13759/637c9f95780cb',
      method: 'post',
      data
    })
  },

  // 我的采购列表
  getMyPurchaseList(data) {
    return request({
      url: '/m13759/68c904d708972',
      method: 'post',
      data
    })
  },

  // 我的采购详情
  getMyPurchaseDetail(data) {
    return request({
      url: '/m13759/68c51faf0d08c',
      method: 'post',
      data
    })
  },


  // 结算单列表
  // pay_status: 0待支付 1已支付
  getSettlementList(data) {
    return request({
      url: '/m13759/68d4d93bb4670',
      method: 'post',
      data
    })
  },

  // 结算单详情
  // aid: 结算单id
  getSettlementDetail(data) {
    return request({
      url: '/m13759/68d5fdca7fbb3',
      method: 'post',
      data
    })
  },


  // 结束采购
  endPurchase(data) {
    return request({
      url: '/m13759/68ca736dc3e93',
      method: 'post',
      data
    })
  },

  // 删除采购订单
  deleteCaigouOrder(data) {
    return request({
      url: '/m13759/69002115c34c3',
      method: 'post',
      data
    })
  },

  // 获取商家报价/配载信息
  getSellerOffer(data) {
    return request({
      url: '/m13759/68ca78134df20',
      method: 'post',
      data
    })
  },

  // 选择商家一轮询价提交
  submitFirstInquiry(data) {
    return request({
      url: '/m13759/68ca7c2e20fbd',
      method: 'post',
      data
    })
  },

  // 选择商家二轮询价提交
  submitSecondInquiry(data) {
    return request({
      url: '/m13759/68ca8b27abb58',
      method: 'post',
      data
    })
  },

  // 获取合作原因列表
  getCooperationReasons(data) {
    return request({
      url: '/m13759/68fc3cc70363e',
      method: 'post',
      data
    })
  },

  // 二轮比价提交
  submitSecondComparison(data) {
    return request({
      url: '/m13759/68cb6758e84db',
      method: 'post',
      data
    })
  },
  // 配载延迟申请
  applyLoadingDelay(data) {
    return request({
      url: '/m13759/68cd0e1035a35',
      method: 'post',
      data
    })
  },
  // 二轮比价记录
  getSecondComparisonRecords(data) {
    return request({
      url: '/m13759/68d0a9734cb7e',
      method: 'post',
      data
    })
  },
  // 申请开票
  applyInvoice(data) {
    return request({
      url: '/m13759/690188baf0d55',
      method: 'post',
      data
    })
  },

  // 热门推荐
  getHotRecommend(data) {
    return request({
      url: '/m13759/69bb5b558bb9f',
      method: 'post',
      data
    })
  },

  // 图片上传
  uploadImage(data) {
    return request({
      url: '/v1/5d5fa8984f0c2',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
  },
  // 修改密码
  changePassword(data) {
    return request({
      url: '/m13759/5caeeba9866aa',
      method: 'post',
      data
    })
  },
  // 获取系统参数
  getSystemParams(data) {
    return request({
      url: '/m13759/64cdb895b79ba',
      method: 'post',
      data
    })
  },
  // 获取关于我们详情
  getAboutUsDetail(data) {
    return request({
      url: '/m13759/641568f1b6f87',
      method: 'post',
      data
    })
  },
  // 获取反馈类型
  getFeedbackTypes(data) {
    return request({
      url: '/m13759/6414719bdc956',
      method: 'post',
      data
    })
  },
  // 提交反馈
  submitFeedback(data) {
    return request({
      url: '/m13759/6414724b96f3f',
      method: 'post',
      data
    })
  },
  // 反馈记录
  getFeedbackRecords(data) {
    return request({
      url: '/m13759/641472eb35317',
      method: 'post',
      data
    })
  },

  // 申请提现
  applyWithdrawal(data) {
    return request({
      url: '/m13759/6a01832a76c18',
      method: 'post',
      data
    })
  },

  // 提现记录
  getWithdrawalRecords(data) {
    return request({
      url: '/m13759/636f481b67084',
      method: 'post',
      data
    })
  },

  // 商家申请提现
  shopWithdrawal(data) {
    return request({
      url: '/m13759/6a01aae8cf1d6',
      method: 'post',
      data
    })
  },

  // 获取当前城市
  getNowCity(data) {
    return request({
      url: '/m13759/6a068bb9b10aa',
      method: 'post',
      data
    })
  },

  // 获取微信支付信息接口
  getWxPayInfo(data) {
    return request({
      url: '/m13759/6a7ad43396380',
      method: 'post',
      data
    })
  },
  
  // 获取支付宝支付信息接口
  getPayInfo(data) {
    return request({
      url: '/m13759/6a2fd287db0c8',
      method: 'post',
      data
    })
  },
  // 获取支付结果接口
  getPayResult(data) {
    return request({
      url: '/m13759/6a310861d37b1',
      method: 'post',
      data
    })
  },
  // 获取支付订单信息
  getPayGoods(data) {
    return request({
      url: '/m13759/6a69b63964079',
      method: 'post',
      data
    })
  },

  // 立即充值
  // payable_money: 应付金额(必填)  product_id: 充值规则id(选填)  pay_type: 支付方式
  recharge(data) {
    return request({
      url: '/m13759/636f632a12277',
      method: 'post',
      data
    })
  },

  // 获取商品第三级分类
  getThirdCategory(data) {
    return request({
      url: '/m13759/6a798cf20bd21',
      method: 'post',
      data
    })
  },
  // 获取聊天用户列表
  getChatUserList(data) {
    return request({
      url: '/m13759/691eda1425b8f',
      method: 'post',
      data
    })
  },
  // 获取历史聊天记录
  // to_user_id: 对方用户id
  getChatHistory(data) {
    return request({
      url: '/m13759/6a87ff25edcd5',
      method: 'post',
      data
    })
  },


}

// 防抖API封装
export const debounceApi = {};

// 为每个API方法创建防抖版本
Object.keys(api).forEach(key => {
  // 存储每个API方法的定时器
  const timers = {};

  debounceApi[key] = (...args) => {
    // 使用JSON.stringify(args)作为唯一标识，确保不同参数的请求不会互相影响
    const keyStr = JSON.stringify(args);

    // 清除之前的定时器
    if (timers[keyStr]) {
      clearTimeout(timers[keyStr]);
    }

    // 返回一个Promise，用于处理异步结果
    return new Promise((resolve, reject) => {
      // 设置新的定时器
      timers[keyStr] = setTimeout(() => {
        // 实际发起API请求
        api[key](...args)
          .then(resolve)
          .catch(reject)
          .finally(() => {
            // 清除定时器
            delete timers[keyStr];
          });
      }, 300); // 默认防抖延迟300ms
    });
  };
});

export default api